import Request from './request';

async function add(content) {// 提交管理端日志
    return Request(
        'post', 
        "api/account-logs", 
        {
            content: content, // 页面标题
            url: window.location.href, // URL地址
        },
        true,
        true,
        true
    );
}

async function pageAccess(content) {// 提交页面访问日志
    return Request(
        'post', 
        "api/account-logs/page-access", 
        {
            content: content, // 页面标题
            url: window.location.href, // URL地址
        },
        true,
        true,
        true
    );
}

export default {
    add,
    pageAccess
};